import { useTranslation } from 'react-i18next';

/**
 * NotFoundMessage component displays a "not found" message
 * for published swimlanes that are no longer available
 */
export function NotFoundMessage() {
  const { t } = useTranslation();

  return (
    <output className="flex items-center justify-center h-screen w-screen bg-bg-surface-base">
      <div className="text-center">
        {/* Warning icon in soft pink circle */}
        <div className="flex justify-center mb-4">
          <div className="flex items-center justify-center w-12 h-12 bg-bg-error-subtler rounded-full">
            <svg
              className="w-6 h-6 text-text-error"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
        </div>
        <h1 className="text-xl font-bold text-text-neutral-primary mb-2">
          {t(($) => $.views.published.notFound.heading)}
        </h1>
        <p className="text-sm text-text-neutral-secondary">
          {t(($) => $.views.published.notFound.description)}
        </p>
      </div>
    </output>
  );
}
